<template>
    <div>
        <div class="row">
            <div class="col-6">
                <div class="text-left section-title" style="padding: 5px;">
                  <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        <template v-if="buildingId">
                            <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / {{ propertyName }} </span>
                        </template>
                        
                    </span>
                  <p style="
            font-size: 15px;
            font-family: inherit;
            font-weight: 500;

            text-transform: uppercase;
          ">
                      Statement
                  </p>
                </div>
            </div>
            <div class="col-6 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                <router-link class="btn btn-table" :to="{
          name: 'property',
          params: { buildingId: buildingId, buildingName: buildingName },
        }"><i class="fas fa-plus"></i></router-link>-->
                    <span style=" width: 30px; height: 30px; border-radius: 5px; background-color: #007DFC; color: white; display: inline-block; padding-left: 5px; padding-right: 5px; text-align: center; cursor: pointer; ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>
                    <period-select style="margin-left:-1px!important;border-left:0px;margin-right:8px;" class="select" id="period" name="period" :building-id="buildingId" v-model="period" />
                    <router-link data-toggle="tooltip" data-placement="top" title="Invoices" class="btn btn-table" :to="{
                    name: 'invoices',
                    params: {
                      propertyId: propertyId,
                      buildingId: buildingId,
                      buildingName: buildingName,
                      propertyName: propertyName,
                    },
                  }"
                                 style="
                              width: 30px;
                              height: 30px;
                              border-radius: 5px;
                              background-color: #212121;
                              color: white!important;
                              display: inline-block;
                              padding-left: 5px;
                              padding-right: 5px;
                              text-align: center;
                              cursor:pointer;
                              margin-right: 8px;
                              ">
                        <i class="fas fa-file-invoice" style="margin-top:7px;" aria-hidden="true"></i>
                    </router-link>
                    <a @click="$router.go(-1)" class="btn btn-cancel" style="padding: inherit; height: 30px; line-height: 17px;">Back</a>
                    <userMenu />
                </div>
            </div>

        </div>
        
         <propertystatement :key="period" :period="period" :owner="true"></propertystatement>

        <div>

             <property-expenses style="margin-top:25px;" :period="period" :owner="true"></property-expenses> 
        </div>
         <property-expense :period="period" style="margin-top:15px;" :owner="true"></property-expense> 
    </div>
</template>
<script>
import { authenticationService, expenseTypeService } from "@/_services";
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      committees: [],
     // buildingId: 0,
     // buildingName: "",
    //  propertyName: "",
    //  propertyId: 0,
      expenseTypeId: 0,
      expenseTypes: [],
      period: 1,
      currentUser: null,
      contact:[],
    };
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  computed:{
  ...mapState({
      building: (state) => state.building.currentBuilding,
      property:(state)=>state.property.currentProperty,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.property != null)
        return  this.property.buildingName;
      return ""
    },
    buildingId(){
      if(this.property != null)
        return  this.property.buildingId;
      return ""
    },
    propertyId(){
      if(this.property != null)
        return  this.property.id;
      return ""
    },
    propertyName(){
      if(this.property != null)
        return  this.property.propertyName;
      return ""
    },
},
  mounted() {
   // this.fetchUserStatement();
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
    this.getProperty();
  },
  methods: {
    forceUpdate() {
      this.$forceUpdate();
    },
    fetchUserStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/statement/userstatement/owner?id=" + this.currentUser.id;
      this.$http
        .get(request, {
          id: this.currentUser.id,
        })
        .then(({ data }) => {
          this.mute = false;

          // console.log(data.building);
          //this.contacts = data.contacts;
          //this.buildingId = data.building.id;
         // this.buildingName = data.building.name;
         // this.propertyName = data.property.propertyName;
         // this.propertyId = data.property.id;
        });
    },
    changed: function () {
    //  this.fetchUserStatement();
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
    },
    fetchStatement: function () {
     // console.log("Building :"+this.buildingId)
      if (!this.buildingId) return;
      this.mute = true;
      //this.buildingId = 3;
      expenseTypeService
        .getExpenseTypesOfBuilding(this.buildingId)
        .then((data) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.expenseTypes = data;
        });
    },
    getProperty: function () {
      this.$http.get("/properties/" + this.propertyId).then((response) => {
        this.contact = response.data.contact;
      });
    },
    deleteItem: function destroy(item) {
      var r = confirm("Are you sure you want to delete committee member?");
      if (r == true) {
        var _this = this;
        this.axios.delete("/committees/" + item.id).then(function () {
          _this.fetchStatement();
          // _this.getVueItems();
          //_this.hasDeleted = false
        });
      }
    },
  },
};
</script>